/** This file is auto generated by convertSvgToJsx.ts */

import icon from './dnb/email'
export default icon
